module.exports = __webpack_public_path__ + "static/media/4.da36e0a7.jpg";